import React, { useState } from 'react'

import { Dropdown } from 'semantic-ui-react'

import { GameType, Stage, StagePack } from 'draft/types'
import { GetStageImage } from 'draft/stages/stage'
import { GetFullStageList, GetStage } from 'draft/utils/stageUtils'

type Props = {
    gameType: GameType,
    stagePack: StagePack,
    onChange: (heroName: string) => void
}

const StageSelect = ({ gameType, stagePack, onChange }: Props) => {
    const [selectedStage, setSelectedStage] = useState<Stage>();
    let options: any = [];

    const stages : Stage[] = GetFullStageList(gameType, stagePack);

    stages.forEach(s => {
        options.push({
            key : s.Name,
            value: s.Name,
            text: s.Name,
            image: { src : GetStageImage(s, gameType)}
        })
    })

    const handleChange = (e:any, data:any) => {
        let stageName = ""
        // On enter click
        if(data.vlaue !== ''){
            stageName = data.value;
        }else{
            stageName = e.target.innerText;
        }

        const fetchedStage = GetStage(stageName, gameType, stagePack)
        if(fetchedStage){
            setSelectedStage(fetchedStage);
            onChange(stageName);
        }
    }

    return (
        <div>
        <Dropdown
            style={{
                minWidth: '230px',
                textAlign: 'left',
                background: '#051122',
                color: '#fff',
                border: `1px solid #dbcf28`,
                
            }}
            label={'Stage'}
            placeholder='Select Stage'
            search
            selection
            options={options}
            onChange={(e,data) => handleChange(e,data)}
            value={selectedStage?.Name}
        />
        </div>
    )
}

export default StageSelect;